import { FunctionComponent, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import VideoStoreSelector from '../../../../Modules/Redux/Global/Video/VideoStoreSelector';
import VideoAnalysisActions from '../../../../Modules/Redux/Global/VideoAnalysis/VideoAnalysisActions';
import { Nullable } from '../../../../Utils/Types';

export const MLVideoPlayer: FunctionComponent = () => {
  const videoRef = useRef<Nullable<HTMLVideoElement>>(null);
  const dispatch = useDispatch();
  const videoSource = useSelector(VideoStoreSelector.videoSource);

  useEffect(() => {
    videoSource?.setVideo(videoRef.current as HTMLVideoElement);
    return (): void => {
      dispatch(VideoAnalysisActions.stopVideoAnalysis());
    };
  }, [videoSource]);

  function startAnalysis(): void {
    dispatch(VideoAnalysisActions.startVideoAnalysis(videoRef.current as HTMLVideoElement));
  }

  return <video autoPlay muted ref={videoRef} onLoadedMetadata={startAnalysis} />;
};
